module.exports = __webpack_public_path__ + "media/site_templates/www.concreting.company/images/testimonials-45564c416931a3bd1756dcf7fc0ed1fa.jpg";